import React from "react";


interface RunningIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string | number;
}

const RunningIcon: React.FC<RunningIconProps> = ({
  className = "",
  width = 11,
  height = 15,
  fill = "black",
  fillOpacity = "0.2",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.94681 2.66667C7.68014 2.66667 8.28014 2.06667 8.28014 1.33333C8.28014 0.6 7.68014 0 6.94681 0C6.21348 0 5.61348 0.6 5.61348 1.33333C5.61348 2.06667 6.21348 2.66667 6.94681 2.66667ZM4.83348 10.6667L5.21348 9L6.61348 10.3333V13.6667C6.61348 14.0333 6.91348 14.3333 7.28014 14.3333C7.64681 14.3333 7.94681 14.0333 7.94681 13.6667V9.90667C7.94681 9.54 7.80014 9.19333 7.53348 8.94L6.54681 8L6.94681 6C7.66014 6.82667 8.69348 7.42 9.85348 7.60667C10.2535 7.66667 10.6135 7.34667 10.6135 6.94C10.6135 6.61333 10.3735 6.34 10.0468 6.28667C9.03348 6.12 8.19348 5.52 7.74681 4.73333L7.08014 3.66667C6.81348 3.26667 6.41348 3 5.94681 3C5.74681 3 5.61348 3.06667 5.41348 3.06667L2.76014 4.18667C2.26681 4.4 1.94681 4.88 1.94681 5.42V7C1.94681 7.36667 2.24681 7.66667 2.61348 7.66667C2.98014 7.66667 3.28014 7.36667 3.28014 7V5.4L4.48014 4.93333L3.41348 10.3333L0.800144 9.8C0.440144 9.72667 0.0868106 9.96 0.0134773 10.32V10.3467C-0.059856 10.7067 0.173477 11.06 0.533477 11.1333L3.27348 11.68C3.98014 11.82 4.67348 11.3733 4.83348 10.6667Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default RunningIcon;